import { isPreferencesEmpty } from "common/learnerPreferences";
import type { OnboardingWizard } from "./types";

export type { OnboardingWizard };

/**
 * Encapsulates logic for launching preferences editor, which is either the
 * onboarding wizard or the edit preferences page.
 */
export class PreferencesEditorLauncher {
  /**
   * If true, the wizard will always be used to launch preferences.
   */
  private useOnboardingWizard = false;

  /**
   * Instance of onboarding wizard.
   */
  private wizard: OnboardingWizard | null = null;

  constructor(useOnboardingWizard: boolean, wizard: OnboardingWizard | null) {
    this.useOnboardingWizard = useOnboardingWizard;
    this.wizard = wizard;
  }

  private openWizard() {
    if (this.wizard) {
      this.wizard.open = true;
    }
  }

  launch() {
    const preferences = this.wizard?.preferences ?? {};
    if (this.useOnboardingWizard || isPreferencesEmpty(preferences)) {
      this.openWizard();
    } else {
      window.location.assign("/users/preferences/edit");
    }
  }
}
